import type { DynamicPropertyDto } from "../../types/DynamicPropertyDto";
import type { DynamicPropertyEntity } from "../../types/DynamicPropertyEntity";

export const DynamicPropertyEntityToDto = ({ ...rest }: Readonly<DynamicPropertyEntity>): DynamicPropertyDto => {
    return { ...rest };
};
